<template>
  <div class="h-screen flex w-full bg-img">
    <div
      class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center"
    >
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div
              class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center"
            >
              <img
                src="@/assets/images/pages/forgot-password.png"
                alt="login"
                class="mx-auto"
              />
            </div>
            <div
              class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg"
            >
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">{{this.resetRequested ? this.$t("ForgotPassword.CheckYourEmailTitle") : this.$t("ForgotPassword.RecoverYourPasswordTitle")}}</h4>
                  <p>
                    {{ instructions }}
                  </p>
                </div>

                <vs-input
                  v-if="!resetRequested"
                  v-validate="'required|email'"
                  data-vv-validate-on="blur"
                  name="email"
                  type="email"
                  label-placeholder="Email"
                  placeholder="Email"
                  v-model="email"
                  class="w-full mt-6"
                />
                <span class="text-danger text-sm">{{
                  errors.first("email")
                }}</span>
                <vs-input
                  v-if="resetRequested"
                  v-validate="'required'"
                  data-vv-validate-on="blur"
                  name="temporaryPassword"
                  type="temporaryPassword"
                  label-placeholder="Temporary Password"
                  placeholder="e.g. 123456"
                  v-model="temporaryPassword"
                  class="w-full mt-6"
                />
                <span class="text-danger text-sm">{{
                  errors.first("temporaryPassword")
                }}</span>
                <vs-button
                  type="border"
                  to="/login"
                  class="px-4 w-full md:w-auto mt-6 mb-8"
                  >{{$t("ForgotPassword.BackToLogin")}}</vs-button
                >
                <vs-button
                  v-if="!resetRequested"
                  @click="recoverPassword"
                  class="float-right px-4 w-full md:w-auto mb-8 mt-6"
                  >{{$t("ForgotPassword.RecoverPassword")}}</vs-button
                >
                <vs-button
                  v-if="resetRequested"
                  @click="login"
                  class="float-right px-4 w-full md:w-auto mb-8 mt-6"
                  >{{$t("Login.Login")}}</vs-button
                >
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      email: "",
      temporaryPassword: "",
      resetRequested: false,
    }
  },
  methods: {
    recoverPassword () {
      if (!this.validateForm) return
      this.$vs.loading()
      this.$store.dispatch("auth/resetPassword", { email: this.email })
        .then(() => {
          this.$vs.loading.close()
          this.resetRequested = true
        }).catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    login () {
      if (!this.temporaryPassword) return

      this.$vs.loading()
      const payload = {
        userDetails: {
          email: this.email,
          password: this.temporaryPassword
        }
      }

      this.$store.dispatch("auth/loginJWT", payload)
        .then(() => { 
          this.$store.dispatch('auth/fetchProfile').then(() => {
            this.$vs.loading.close()
          })
         })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
  },
  computed: {

    validateForm () {
      return !this.errors.any() && this.email !== ""
    },
    instructions () {
      return this.resetRequested ? this.$t("ForgotPassword.PleaseCheckInbox") : this.$t("ForgotPassword.PleaseEnterEmail")
    }
  },
}
</script>
